<template>
    <div class="rangaistustaulukko">
        <div class="osa" v-for="(part, i) in taulukko" :key="'taulukko-' + i">
            <h3>{{ part.name }}</h3>
            <p v-if="part.description">{{ part.description }}</p>
            <table>
                <tbody>
                    <tr>
                        <th>Rike</th>
                        <th v-for="n in part['max-offence-columns']" :key="'taulukko-' + i + '-n.rike-' + n">
                            {{ n + '. rike' }}
                        </th>
                    </tr>

                    <tr v-for="(offence, j) in part.offences" :key="'taulukko-' + i + '-' + j">
                        <th>
                            {{ offence.name }}
                            <span class="corrective" v-if="offence.corrective">{{ offence.corrective }}</span>
                        </th>
                        <td v-for="n in part['max-offence-columns']" :key="'taulukko-' + i + '-' + j + '-' + n">
                            {{ offence[n] }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
const data = require('@/assets/rangaistukset.json')

export default {
    name: 'Rangaistustaulukko',
    components: {},
    data: () => {
        return {}
    },
    computed: {
        taulukko: () => data
    }
}
</script>

<style scoped>
.rangaistustaulukko {
    max-width: 100%;
    box-sizing: border-box;
    padding-right: 1em;
    margin-bottom: 1.5em;
    overflow: hidden;
}
table {
    border-collapse: collapse;
    width: 100%;
    max-width: 880px;
    overflow: scroll;
}

table * {
    box-sizing: border-box;
}

.corrective {
    font-weight: 300;
    font-size: 0.95em;
}

tr:first-child > th {
    color: var(--table-head);
    font-weight: 400;
    font-style: italic;

}

tr:nth-child(odd) {
    background-color: var(--table-odd);
}
tr:nth-child(even) {
    background-color: var(--table-even);
}

tr {
    border-collapse: collapse;
}

td,
th {
    padding: 0.5em 0.6em;
    margin: 0.2em;
    max-width: 220px;
    min-width: 50px;
}

tr:first-child {
    background: var(--accent-gradient-down);
}

th:first-child {
    max-width: 200px;
}

tr:first-child > th:first-child {
    border-radius: 0.35em 0 0 0;
}

tr:first-child > th:last-child {
    border-radius: 0 0.35em 0 0;
}

tr:last-child > th:first-child {
    border-radius: 0 0 0 0.35em;
}

tr:last-child > td:last-child {
    border-radius: 0 0 0.35em 0;
}

th {
    text-align: left;
    padding: 0.3em 0.6em;
}

tr:last-child > td,
tr:last-child > th {
    padding-bottom: 0.8em;
}

th:first-child {
    max-width: 150px;
}

th:last-child, td:last-child {
    min-width: 60px;
}

@media screen and (max-width: 900px) {
    td,
    th {
        padding: 0.5em 0.1em;
        min-width: 40px;
        font-size: 0.86em;
    }

    th {
        max-width: 140px;
    }

    th:first-child,
    td:first-child {
        padding-left: 0.7em !important;
        padding-right: 0.3em;
    }
}
</style>
